module.exports = __webpack_public_path__ + "img/back_03.38a1bb2a.png";